export enum WebSocketEvent {
  TABLES_SUBSCRIBE = 'tablesSubscribe',
  TABLES_INIT = 'tablesInit',
  TABLES_CREATE = 'tablesCreate',
  TABLES_UPDATE = 'tablesUpdate',
  TABLES_DELETE = 'tablesDelete',

  EXCEPTION = 'exception'
}
